import logo from './logo.svg';
import './App.css';

import React, {useState, useEffect, useLayoutEffect,useHistory} from 'react'
import {useAuthDispatch, useAuthState} from "./Context/auth-context";
import MainPages from './pages/MainPages'
import {toast, ToastContainer} from "react-toastify";
import axios from "axios";

import {actionTypes} from "./Context/reducer";




export default function App(){




    const dispatch = useAuthDispatch();




    useLayoutEffect( ()=>{
        
        dispatch({
            type: actionTypes.LOGIN_REQUEST,

        })

        axios.get('https://api.sinatether.com/Auth/GetStateUser/',{
           withCredentials:true
       }).then((res)=>{
            if(res.status == 200){
                dispatch({
                type:actionTypes.LOGIN_SUCCESS,
                    payload: {
                            phone: res.data['phone'],
                            name: res.data['name'],
                            isEhraz: res.data['isEhraz']


                        }
            })
            }
        }).catch((error)=>{
            if(error){
                    dispatch({
                        type:actionTypes.LOGOUT
                    })


                }






        })
    },[])












    return (
        <>
                  <MainPages/>
                  <ToastContainer
                                position="bottom-right"
                                theme={"colored"}
                                autoClose={5000}
                                hideProgressBar={false}
                                newestOnTop={false}
                                closeOnClick
                                rtl
                                pauseOnFocusLoss
                                draggable
                                pauseOnHover

                    />
        </>

    )







}

